import { FileDownload } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { buttonStyle } from "~/constants";

const VideoDownloadButton = (props: { url: string }) => {
  return (
    <Box
      component="a"
      href={props.url}
      sx={{ ...buttonStyle, color: "inherit" }}
      download
    >
      <Button
        disableElevation
        variant="outlined"
        color="inherit"
        startIcon={<FileDownload />}
        sx={{ ...buttonStyle }} // Needed for public links styling
      >
        Download
      </Button>
    </Box>
  );
};

export default VideoDownloadButton;
